import { Component, Inject } from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {DialogTextModel} from "../../core/cms/models/dialog.text.model";

@Component({
    selector: 'app-dialog',
    templateUrl: './dialog.component.html',
    styleUrls: ['./dialog.component.scss'],
    standalone: false
})
export class DialogComponent {

  constructor(@Inject(MAT_DIALOG_DATA) public data: DialogTextModel,
              public dialogRef: MatDialogRef<DialogComponent>,
              ) {

  }
}
